/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, useRef } from 'react'
import './Slider.scss'

import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import './Menu.scss'

import { Autoplay, Navigation } from 'swiper'

import Header from '../../components/Header'
// import FoodItem from '../../components/FoodItem'
import Footer from '../../components/footer'

import logoCategory from '../../assets/pictures/logo.png'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { get, post } from '../../services/https'

import { baseUrl } from '../../services/base'
import { ToRial } from '../../services/money'

import { useSelector, useStore, useDispatch } from 'react-redux'
import { addToBasketAction, removeItemAction, increaseItemAction, reduceItemAction } from '../../redux/store/Basket'

import { useNavigate ,useLocation } from 'react-router-dom'

export default function index() {
  const navigate = useNavigate()
  const location = useLocation()

  const id = localStorage.getItem('shopId')
  const [categories, setCategories] = useState([])
  const [categorySelect, setCategorySelect] = useState('all')
  const [foods, setFoods] = useState([])
  const [showFood, setShowFood] = useState(false)
  const [sliders, setSlider] = useState([])
  const [shop, setShop] = useState()
  // eslint-disable-next-line no-unused-vars
  const [food, setFood] = useState({
    name: 'name',
    price: '0',
    discountPrice: '0',
    pic: '',
    description: '',
    status: true
  })

  const [shopsStatus, setShopStatus] = useState(true)
  const scrollRef = useRef()

  const [items, setItems] = useState([])

  const dispatch = useDispatch()
  const stores = useStore()
  const basket = useSelector(state => state.basket)

  const increaseItemHandler = (e) => {
    dispatch(increaseItemAction(e.target.id))
    const basketArray = []
    basket.map(item => {
      return basketArray.push(item)
    })
    setItems(basketArray)
  }

  useEffect(() => {
    const store = stores.getState()
    setItems(store.basket)

    if (location.state) {
      const {foods, categories, sliders, scrollPosition, shop} = location.state
      setFoods(foods)
      setCategories(categories)
      setSlider(sliders)
      setShop(shop)
      setTimeout(() => {
        scrollRef.current.scrollTop = scrollPosition
      }, (10))
    } else {
      const shopId = localStorage.getItem('shopId')
      if (shopId === null) {
        navigate('/')
      }
      get(`/api/front/categories/${shopId}`)
        .then(response => {
          setCategories(response.data.data)
        })
        .catch(error => {
          notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        })
  
      get(`/api/front/foods`)
        .then(response => {
          setFoods(response.data.data)
        })
        .catch(error => {
          notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        })
  
      get(`/api/front/shops/${id}`)
        .then(response => {
          setShop(response.data.data[0])
          response.data.data.map(item => {
            setShopStatus(item.status)
          })
        })
  
      get(`/api/front/sliders`)
        .then(response => {
          setSlider(response.data.data.docs[0].slider)
        })
    }
  }, [id, location.state, navigate, stores])

  const categoryHandler = (e) => {
    setCategorySelect(e.target.id)
    const id = e.target.id

    if (id === 'all'){
      get(`/api/front/foods`)
      .then(response => {
        return setFoods(response.data.data)
      })
      .catch(error => {
        return notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
    } else {
      get(`/api/front/foods/cat/${id}`)
        .then(response => {
          return setFoods(response.data.data)
        })
        .catch(error => {
          return notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        })
    }
  }

  const [scrollPosition,setScrollPosition] = useState()

  const handleScroll = (event) => {
    setScrollPosition(event.target.scrollTop)
  }

  const showFoodHandler = (e) => {
    const id = e.target.id
    navigate(`/menu/${id}`, { state: { foods: foods, sliders: sliders, categories: categories, scrollPosition, shop: shop }})
    // if(id != 'foodCard') {
    //   setShowFood(true)
    //   foods.map(item => {
    //     item.data.map(food => {
    //       if (food._id === id) {
    //         setFood({
    //           name: food.name,
    //           price: ToRial(food.price),
    //           discountPrice: ToRial(food.discountPrice),
    //           pic: `${baseUrl.base}${food.pic}`,
    //           description: food.description,
    //           status: food.status
    //         })
    //       }
    //     })
    //   })
    // }
  }

  const addToBasketHandler = (e) => {
    const store = stores.getState()

    if (store.basket.length === 0) {
      foods.forEach(food => {
        food.data.map(item => {
          if (item._id === e.target.id) {
            dispatch(addToBasketAction(item))
          }
        })
      })
    } else {
      const validate = store.basket.some(item => item._id === e.target.id)
      if (validate) {
        return dispatch(removeItemAction(e.target.id))
      }
      return foods.forEach(food => {
        food.data.map(item => {
          if (item._id === e.target.id) {
            dispatch(addToBasketAction(item))
          }
        })
      })
    }
  }

  const reducerHanlder = (e) => {
    const item = basket.filter(item => item._id === e.target.id)
    if (item[0].count === 1) {
      dispatch(removeItemAction(item[0]._id))
    } else {
      dispatch(reduceItemAction(item[0]._id))
    }
  }

  const searchHandler = (e) => {
    console.log(e.target.value, id)

    if (e.target.value.length >= 3) {
      post(`/api/front/foods/search/${e.target.value}`, { id: id })
      .then(response => {
        console.log(response.data.data)
        setFoods(response.data.data)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
    } else {
      get(`/api/front/foods`)
        .then(response => {
          setFoods(response.data.data)
        })
        .catch(error => {
          notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        })
    }
  } 
  
  return (
    <>
      <div id='menu'>
        <ToastContainer rtl />
        <div style={showFood ? { display: '' } : { display: 'none' }}>
          <div className='singleFood'>
            <div className='singleFoodBody'>
              <div className='singleFoodPic'>
                <img src={food.pic} alt='pic' />
                <span className='hasBeen' style={food.status ? {display: 'none'} : {display: ''}}>ناموجود</span>
              </div>
              <div className='singleFoodTitle'>
                {food.name}
              </div>
              <div className='singleFoodSubitle'>
                {food.description}
              </div>
              <div className='singleFoodDetail' style={food.status ? { display: '' } : { display: 'none' }}>
                <span style={food.discountPrice != 0 ? { fontSize: '12px', textDecoration: 'line-through' } : {}}>{food.price} تومان</span>
                <span style={food.discountPrice == 0 ? { display: 'none' } : {}}>{food.discountPrice} تومان</span>
                <span className='singleFoodAdd' style={{ display : 'none' }}></span>
              </div>
              <button className='singleFoodButton' onClick={() => setShowFood(false)}>
                بازگشت به منو
              </button>
            </div>
          </div>
        </div>
        <Header name={'رستوران کانولی'} />
        <div className='categorySection'>
          <div className='categoryBody'>
            <div className='category' id={'all'} onClick={categoryHandler}>
              <div className="icon" id={'all'}>
                <img src={shop ? `${baseUrl.base}${shop.logoUrl}` : logoCategory} alt="CategoryIcon" id={'all'} />
              </div>
              <div className="title" style={categorySelect === 'all' ? { color: '#ff4d03' } : {}} id={'all'}>
                تمامی منو
              </div>
            </div>
            {categories.map(item => (
              <div className='category' key={item._id} id={item._id} onClick={categoryHandler}>
                <div className="icon" id={item._id}>
                  <img src={`${baseUrl.base}${item.icon}`} alt="CategoryIcon" id={item._id} />
                </div>
                <div className="title" style={categorySelect === item._id ? { color: '#ff4d03' } : {}} id={item._id}>
                  {item.title}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className='body'>
        </div>
        <div className='scroll' onScroll={handleScroll} ref={scrollRef} style={{ overflowY: "scroll",height: '100vh' }}>
          <Swiper 
            spaceBetween={20}
            slidesPerView={1.2}
            centeredSlides={true}
            autoplay={{
              delay: 7500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            modules={[Autoplay, Navigation]}
            style={{ padding: '1em 0 0 0' }}
            >
            {/* {sliders ? sliders.map((item, index) => (
                <SwiperSlide className='swiperSlide' key={index}>
                  <a href={item.sliderLink}>
                    <img src={item.sliderPicture} alt='sliderOne' width='100%' height='100%' />
                  </a>
                </SwiperSlide>
            )) : ''} */}
          </Swiper>
          <div className='searchBox'>
            <input onChange={searchHandler} type="text" placeholder='نام غذا یا نوشیدنی را وارد کنید ...' />
          </div>
          <div className='offShopStatus' style={shopsStatus ? { display: 'none' } : { display: '' }}>سایت رستوران در دسترس نمیباشد</div>
          <div className='offShopStatus' style={shopsStatus ? { display: 'none' } : { display: '' }}>جهت سفارش با شماره : 2-42135631-013</div>
          {foods ? foods.map(item => 
              item.category[0].shop == localStorage.getItem('shopId') ? (
              <div className='foods' key={item._id}>
                <div className='foodTitle'>{item.category[0].title}</div>
                {item.data.map(food => 
                  food.shop == localStorage.getItem('shopId') ? (
                  <section id={food._id} className='foodCard' key={food._id}>
                    <div id={food._id} className='pic' onClick={showFoodHandler}>
                      <span id={food._id} className='hasBeen' style={food.status ? {display: 'none'} : {display: ''}}>ناموجود</span>
                      <img id={food._id} src={`${baseUrl.base}${food.pic}`} alt='' />
                    </div>
                    <div id={food._id} className='detail' onClick={showFoodHandler}>
                      <div id={food._id} className='title'>
                        <span id={food._id}>{food.name}</span>
                        <span id={food._id}>{(food.description).substring(0, 50) + ' ... '}</span>
                      </div>
                      <div id={food._id} className='price'>
                        <span id={food._id} style={food.discountPrice != 0 ? { fontSize: '12px', textDecoration: 'line-through' } : {}}>{ToRial(food.price)} تومان</span>
                        <span id={food._id} style={food.discountPrice == 0 ? { display: 'none' } : {}}>{ToRial(food.discountPrice)} تومان</span>
                      </div>
                    </div>
                    <div id={food._id}  style={food.status && shopsStatus ? {display: ''} : {display: 'none'}}>
                      {basket.some(itemBasket => itemBasket._id === food._id) ? 
                        <div id={food._id} className='detailsCount'>
                          <span className='down' id={food._id} onClick={reducerHanlder}></span>
                          <span className='count'>{items.length !== 0 ? basket.map(item => 
                            item._id === food._id ? (
                              item.count
                            ) : ''
                          ) :  1 }</span>
                          <span className='addDetails' id={food._id} onClick={increaseItemHandler}></span>
                        </div> :
                        <span className='add' onClick={addToBasketHandler} id={food._id}>+</span>
                      }
                    </div>
                  </section>
                ) : '')}
              </div>
            ) : ''
          ) : ''}
        </div>
        <Footer page={'home'} />
      </div>
      <button onClick={() => navigate('/card')} style={basket.length === 0 ? { display: 'none' } : {}} className='endOrderButton'>تکمیل سفارش</button>
    </>
  )
}
